interface PageHeaderProps {
  title: string
  description: string
  backgroundImage?: string
}

export default function PageHeader({ title, description, backgroundImage }: PageHeaderProps) {
  return (
    <div 
      className="relative py-16 sm:py-20"
      style={{
        background: backgroundImage 
          ? `linear-gradient(135deg, rgba(20,42,73,0.8) 0%, rgba(12,67,148,0.8) 100%), url(${backgroundImage})`
          : `#006D77`,
        backgroundSize: backgroundImage ? 'cover' : undefined,
        backgroundPosition: backgroundImage ? 'center' : undefined,
      }}
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center mt-8">
          <h1 className="text-2xl md:text-3xl lg:text-4xl font-serif text-white leading-tight mb-6">
            {title}
          </h1>
          <p className="text-sm md:text-base text-gray-200 font-light leading-relaxed">
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}
